<i18n
  src="@/locales/components/views/customer/quality_control/destination/container_info.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="my-8" v-if="container">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ show_container_code ? container?.container_code : "Contenedor" }}
    </h1>
    <div class="panel">
      <div class="panel-body">
        <div class="divide-slate-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container.agro_exporter") }}
              </dt>
              <dd class="content-data">
                {{ container?.agro_exporter?.name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container.crop") }}
              </dt>
              <dd class="content-data">
                {{ container?.crop?.name }}
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_crop_category") }}
              </dt>
              <dd class="content-data">
                {{ container?.category_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_crop_variety") }}
              </dt>
              <dd class="content-data">
                {{ container?.variety_name }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_brand") }}:
              </dt>
              <dd class="content-data">
                {{ container?.brand_name }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerQualityControlContainerInfo",
  props: {
    container: {
      type: Object,
      required: true
    },
    show_container_code: {
      type: Boolean,
      default: true
    }
  }
};
</script>
